import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { hideAll } from 'tippy.js';
import { listPlacement } from './Constants';
import { StyledTippy, TipperContent, TipperTooltip, WrapperButton } from './Tipper.styled';

export const placements = Object.keys(listPlacement);

export const listTypes = ['tooltip', 'menu', `detail_modal`];

export const getExtraConfiguration = ({ place, content, theme, disabled, configuration, utagFunction, utagParams, brand }) => ({
	content: (
		<TipperTooltip className={configuration.className} onClick={(e) => e.stopPropagation()}>
			<WrapperButton>{content}</WrapperButton>
		</TipperTooltip>
	),
	placement: listPlacement[place] ? listPlacement[place].placement : 'bottom',
	onShow: () => hideAll(),
	theme,
	brand,
	disabled,
	...configuration,
	onTrigger: (instance, e) => {
		e.stopPropagation();
		if (utagFunction) utagFunction(utagParams.cruise, utagParams.container, utagParams.brand);
	},
	onUntrigger: (instance, e) => {
		e.stopPropagation();
	},
});

const Tipper = (tipperParams) => {
	const { configuration, children } = tipperParams;

	const { brand } = useContext(CruiseSearchContext);

	const containerContent = getExtraConfiguration({
		...tipperParams,
		brand,
	});

	return (
		<TipperContent className={configuration.className}>
			<StyledTippy {...containerContent}>
				<span>{children}</span>
			</StyledTippy>
		</TipperContent>
	);
};

Tipper.propTypes = {
	configuration: PropTypes.oneOfType([PropTypes.element, PropTypes.object]).isRequired,

	content: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.elementType]),
	children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
	placement: PropTypes.oneOf(placements).isRequired,
	type: PropTypes.oneOf(listTypes).isRequired,
	theme: PropTypes.string.isRequired,
	disabled: PropTypes.bool,
	utagFunction: PropTypes.func,
	utagParams: PropTypes.object,
};

Tipper.defaultProps = {
	children: '',
	content: '',
	disabled: false,
};

export default Tipper;
